export default "__VITE_ASSET__G6R6ap7j__"